import { gql } from '@apollo/client';

// NOTE: Only exists on api's `fdic` branch.
export const SAVE_SALE_BID_DRAFT = gql`
  mutation SaveSaleBidDraft($input: SaveSaleBidDraftInput!) {
    saveSaleBidDraft(input: $input) {
      __typename
      sale_id
      round
      structure
      offering_ids
      pct_e4
      amount_cents
      saved_at
    }
  }
`;
